import * as types from "../actions/actionTypes";
import initialState from "./initialState";

const enrollmentsReducer = (state = initialState.enrollments, action) => {
  switch (action.type) {
    case types.LOAD_ENROLLMENTS_SUCCESS:
      return action.enrollments;
    case types.CREATE_ENROLLMENT_SUCCESS:
      return [...state, { ...action.enrollment }];
    case types.UPDATE_ENROLLMENT_SUCCESS:
      return state.map(enrollment => (enrollment.id === action.enrollment.id ? action.enrollment : enrollment));
    default:
      return state;
  }
};

export default enrollmentsReducer;
